import React from 'react'
import CloudStorage from '../../../../CloudStorage/CloudStorage'

export default function CloseSearchbutton({ searchtext, setSearchtext }) {
    return (
        <>
            {searchtext && (
                <button
                    type="button"
                    className="btn clear-btn clear-img-btn"
                    style={{ marginRight: 25 }}
                    onClick={() => { setSearchtext('') }}
                >
                    <img
                        src={`${CloudStorage.cloudurl}/Assets/Images/expertregisteration/close-icon.svg`}
                        alt="Clear"
                    />
                </button>
            )}
        </>
    )
}
